// TODO: Removing race for now as part of SOF-3921.  Replace w/ CB group eventually.
const ProfileTypes = {
  GENDER: {
    title: "GENDER",
    qid: 484,
  },
  AGE: {
    title: "AGE",
    qid: 7078,
  },
  INCOME: {
    title: "INCOME",
    qid: 625781,
  },
  EDUCATION: {
    title: "EDUCATION",
    qid: 131788,
  },
  URBANICITY: {
    title: "URBANICITY",
    qid: 497,
  },
  PARENTAL_STATUS: {
    title: "PARENTAL STATUS",
    qid: 503,
  },
};

export default ProfileTypes;
